export const GET_MANUFACTURERS = 'GET_MANUFACTURERS';
export const GET_MANUFACTURERS_SUCCESS = 'GET_MANUFACTURERS_SUCCESS';
export const GET_MANUFACTURERS_ERROR = 'GET_MANUFACTURERS_ERROR';
export const RESET_MANUFACTURERS = 'RESET_MANUFACTURERS';
